<template>
  <div class="inline-flex flex-col">
    <slot name="label">
      <mia-feature-label
        v-if="!withoutLabel"
        text="Status"
        :for="uniqueId"
      />
    </slot>

    <div
      v-if="isMultiSelect"
      class="grid row-gap-4 col-gap-8"
      :class="`grid-cols-${columns}`"
    >
      <label
        v-for="status in availableStatusOptions"
        :key="status.id"
        class="flex items-center font-normal cursor-pointer"
      >
        <mia-checkbox
          :checked="value.includes(status.id)"
          class="w-6 h-6"
          @input="onChecked(status, $event)"
        />

        <span
          class="ml-2"
          v-text="status.title"
        />
      </label>
    </div>
    <mia-select
      v-else
      :value="value"
      @input="$emit('input', $event)"
    >
      <option value="">
        Status auswählen
      </option>
      <option
        v-for="status in availableStatusOptions"
        :key="status.id"
        :value="status.id"
        v-text="status.title"
      />
    </mia-select>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FeatureLabel from '@/components/cars/edit/FeatureLabel.vue'

export default {
  name: 'MiaStatusSelect',

  components: {
    'mia-feature-label': FeatureLabel
  },

  props: {
    value: {
      type: [String, Array],
      required: true
    },

    statusOptions: {
      type: Array,
      default() {
        return []
      }
    },

    withoutLabel: {
      type: Boolean,
      default: false
    },

    columns: {
      type: Number,
      default: 4
    }
  },

  data() {
    return {
      currentValue: null
    }
  },

  computed: {
    ...mapGetters({
      fetchedStatusOptions: 'statusOptions'
    }),

    uniqueId() {
      // eslint-disable-next-line no-underscore-dangle
      return `status-${this._uid}`
    },

    isMultiSelect() {
      return Array.isArray(this.value)
    },

    hasCustomStatusOptions() {
      return this.statusOptions.length > 0
    },

    availableStatusOptions() {
      return this.hasCustomStatusOptions ? this.statusOptions : this.fetchedStatusOptions
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.currentValue = this.availableStatusOptions.find(({ id }) => id === value) || null
      }
    }
  },

  async created() {
    if (this.hasCustomStatusOptions) return

    this.$store.dispatch('loadStatusOptions')
  },

  methods: {
    onChecked(status, event) {
      if (event.target.checked) {
        this.$emit('input', [...this.value, status.id])
      } else {
        this.$emit('input', this.value.filter(id => id !== status.id))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep label {
  @apply mb-0;
}
</style>
